<template>
  <div class="h-full overflow-y-auto flex flex-col gap-2 w-full">
    <div v-if="hasBirthday?.hasBirthday"
         class=" mb-4 w-full flex flex-col gap-2 rounded-lg border bg-gradient-to-bl from-gray-50 via-primary-100 to-primary-300 relative pr-4 py-6 pl-16">
      <img src="../../../../../assets/img/admin/has-birthday.png" class="absolute left-0.5 top-0 w-20" alt="">
      <span class="font-medium">יום ההולדת יחול החודש!</span>
      <span
        class="text-sm text-gray-700"> ללקוח/ה יש החודש יום הולדת בתאריך {{ DateTime.fromISO(customer.loyalty?.birthday as string).toLocaleString(DateTime.DATE_MED) }}, תמסרו לו מזל טוב גם מאיתנו :)</span>
    </div>
    <div class="w-full flex flex-col gap-1">
      <div class="flex justify-between items-center w-full">
        <span class="font-medium">שם הלקוח</span>
        <span class="underline font-medium cursor-pointer" @click="clickEditName">
          {{ editName ? 'ביטול' : 'עריכה' }}
        </span>
      </div>
      <div class="flex items-center gap-3">
        <span v-if="!editName" class="text-gray-800">{{ customer?.fullName }}</span>
        <div v-else class="flex  relative w-full">
          <InputText
            v-model="newClientName"
            size="small"
            class="w-full outline-none !shadow-none" />
          <div
            class="flex-none px-4 cursor-pointer justify-center h-[39px] flex items-center !absolute z-1 text-sm top-0 left-0 font-medium"
            @click="saveUpdatedName">
            <span v-if="!editNameButtonLoading">עדכון</span>
            <i v-else class="pi pi-spin pi-spinner" />
          </div>
        </div>
      </div>
    </div>
    <Divider />
    <div class="w-full flex flex-col gap-2">
      <div class="flex justify-between items-center w-full">
        <span class="font-medium">פרטי יצירת קשר</span>
        <div class="flex gap-2 items-center">
          <span v-wave
                class="rounded-full flex items-center justify-center p-2 border border-green-500 bg-green-50 cursor-pointer"
                @click="sendMessage">
             <i class="pi pi-whatsapp text-2xl" />
            </span>
          <!-- Calling needs the actual number, so it goes away for restricted viewers -->
          <span v-if="canViewContact"
                v-wave
                class="rounded-full flex items-center justify-center p-2 border border-blue-500 bg-blue-50 cursor-pointer"
                @click="openLinkNewTab(`tel:${customer.phoneNumber}`)">
             <i class="pi pi-phone text-2xl" />
            </span>
        </div>
      </div>
      <div class="flex items-center gap-3">
        <div v-if="canViewContact" class="flex relative w-full gap-3">
          <span
            class="text-left text-sm text-primary-500 border border-primary-500 flex gap-1 items-center px-2 rounded bg-primary-50">
              <span>{{ formatPhone(customer.phoneNumber) }}</span>
              <i class="pi pi-phone" style="font-size: 0.5rem" />
          </span>
          <span v-if="customer.email"
                class="text-left text-sm text-primary-500 border border-primary-500 flex gap-1 items-center px-2 rounded bg-primary-50">
              <span>{{ customer.email }}</span>
              <i class="pi pi-at" style="font-size: 0.5rem" />
            </span>
        </div>
        <span v-else class="text-sm text-surface-400 flex items-center gap-1.5">
          <i class="pi pi-lock" style="font-size: 0.7rem" />
          פרטי הקשר מוסתרים — ניתן לשלוח הודעה ללקוח/ה
        </span>
      </div>
    </div>
    <Divider />
    <div class="w-full flex flex-none gap-3 justify-start items-center relative overflow-hidden select-none">
      <i class="rounded-full p-2.5 pi text-gray-500 bg-gray-100 pi-tags" style="font-size: 0.85rem;" />
      <div class="w-full flex justify-between items-center">
        <div class="flex flex-col gap-1 items-start justify-start relative z-10">
          <span class="font-medium">תגיות</span>
          <span class="text-xs pe-6 text-gray-500">הוסיפו תגיות, מיינו את הלקוחות ושלחו הודעות לפי תגית</span>
        </div>
        <span class="underline font-medium cursor-pointer" @click="addCustomerTags">עריכה</span>
      </div>
    </div>
    <div class="w-full flex gap-3 flex-none mt-4 justify-start items-center relative overflow-hidden select-none">
      <i class="rounded-full p-2.5 pi text-gray-500 bg-gray-100 pi-sparkles" style="font-size: 0.85rem;" />
      <div class="w-full flex justify-between items-center">
        <div class="flex flex-col gap-1 items-start justify-start relative z-10">
          <span class="font-medium">שירותים בלעדיים</span>
          <span class="text-xs pe-6 text-gray-500">תנו ללקוחות מסויימים גישה לשירותים שרק הם יוכלו להזמין.</span>
        </div>
        <span class="underline font-medium cursor-pointer" @click="editCustomerLimitedServices">עריכה</span>
      </div>
    </div>
    <div class="w-full flex gap-3 flex-none mt-4 justify-start items-center relative overflow-hidden select-none">
      <i class="rounded-full p-2.5 pi text-gray-500 bg-gray-100 pi-file" style="font-size: 0.85rem;" />
      <div class="w-full flex justify-between items-center">
        <div class="flex flex-col gap-1 items-start justify-start relative z-10">
          <span class="font-medium">הערה כללית</span>
          <span class="text-xs pe-6 text-gray-500 whitespace-pre-wrap">{{ customer?.internalNote || 'הוסיפו הערה כללית על הלקוח' }}</span>
        </div>
        <span class="underline font-medium cursor-pointer" @click="openEditInternalNote">עריכה</span>
      </div>
    </div>
    <div class="w-full flex gap-3 mt-4 flex-none justify-start items-center relative overflow-hidden select-none">
      <i class="rounded-full p-2.5 pi text-red-500 bg-red-50 pi-exclamation-triangle" style="font-size: 0.85rem;" />
      <div class="w-full flex justify-between items-center">
        <div class="flex flex-col gap-1 items-start justify-start relative z-10">
          <span class="font-medium">הערות חשובות</span>
          <span class="text-xs pe-6 whitespace-pre-wrap" :class="customer?.warningNote ? 'text-red-600' : 'text-gray-500'">{{ customer?.warningNote || 'הוסיפו הערות חשובות שיוצגו בכל תור של הלקוח, כמו אלרגיות וכדומה.' }}</span>
        </div>
        <span class="underline font-medium cursor-pointer" @click="openEditWarningNote">עריכה</span>
      </div>
    </div>
    <div class="w-full flex gap-3 mt-4 flex-none justify-start items-center relative overflow-hidden select-none">
      <i class="rounded-full p-2.5 pi text-gray-500 bg-gray-100 pi-palette" style="font-size: 0.85rem;" />
      <div class="w-full flex justify-between items-center">
        <div class="flex flex-col gap-1 items-start justify-start relative z-10">
          <span class="font-medium">סימון לקוח</span>
          <span class="text-xs pe-6 text-gray-500">{{ markerSubtitle }}</span>
        </div>
        <span class="underline font-medium cursor-pointer" @click="openEditCustomerMarker">עריכה</span>
      </div>
    </div>
    <div class="w-full flex gap-3 mt-4 flex-none justify-start items-center relative overflow-hidden select-none">
      <i class="rounded-full p-2.5 pi text-gray-500 bg-gray-100 pi-phone" style="font-size: 0.85rem;" />
      <div class="w-full flex justify-between items-center gap-3">
        <div class="flex flex-col gap-1 items-start justify-start relative z-10">
          <span class="font-medium">קביעת תור טלפונית בלבד</span>
          <span class="text-xs pe-6 text-gray-500">הלקוח לא יוכל לקבוע תור אונליין ויתבקש ליצור קשר טלפוני עם העסק.</span>
        </div>
        <InputSwitch :modelValue="!!customer?.scheduleByPhoneOnly" :disabled="phoneOnlyLoading" @update:modelValue="togglePhoneOnly" class="min-w-12" />
      </div>
    </div>
    <Divider />
    <CustomerCustomFields :customer="customer" @updated="emit('updated')" />
    <Button label="מחיקת לקוח" severity="danger" text class="mt-auto mb-4 flex-none p-8" @click="removeAccount"/>
  </div>
</template>

<script setup lang="ts">
import { computed, PropType, ref } from 'vue';
import {
  CUSTOMER_MARKER_COLOR_DEFAULT,
  CUSTOMER_MARKER_COLORS,
  ICustomer
} from '@torim-app/types';
import { CustomersApi } from '@app/api/admin';
import { useToast } from 'vue-toastification';
import { useAdminClientsStore, useAdminStore } from '@app/stores';
import { DateTime } from 'luxon';
import { useDrawer } from '@torim-app/shared-components';
import AddCustomerTags from '@app/components/admin/modals/AddCustomerTags.vue';
import AddCustomerLimitService from '@app/components/admin/modals/AddCustomerLimitService.vue';
import EditCustomerNote from '@app/components/admin/modals/EditCustomerNote.vue';
import EditCustomerColorMarker from '@app/components/admin/modals/EditCustomerColorMarker.vue';
import CustomerCustomFields from '@app/components/admin/pages/customer/CustomerCustomFields.vue';
import SendCustomerMessage from '@app/components/admin/modals/SendCustomerMessage.vue';
import { openLinkNewTab, sendWhatsApp } from '@torim-app/utils';
import { trackEvent } from '@app/composables/posthog';
import { useConfirm } from 'primevue/useconfirm';
import { useNavigation } from '@app/composables/navigation';
import { AdminRouteNames } from '@app/router/route-names';

const toast = useToast();
const adminClientsStore = useAdminClientsStore();
const adminStore = useAdminStore();
const { openDrawer, closeDrawer } = useDrawer();
const canViewContact = computed(() => adminStore.getCanViewCustomerContact);
const confirm = useConfirm();
const { goTo } = useNavigation();

const emit = defineEmits(['updated']);
const props = defineProps({
  customer: {
    type: Object as PropType<ICustomer>,
    required: true,
    default: () => {
    }
  }
});

const editName = ref(false);
const newClientName = ref('');
const editNameButtonLoading = ref(false);


const hasBirthday = computed<{ hasBirthday: boolean; date?: string }>(() => {
  const { birthday } = props.customer?.loyalty ?? {};
  if (!birthday) return { hasBirthday: false };

  const customerHasBirthday = DateTime.fromISO(birthday as string).hasSame(DateTime.local(), 'month');
  return {
    hasBirthday: customerHasBirthday,
    date: customerHasBirthday ? DateTime.fromISO(birthday as string).toLocaleString(DateTime.DATE_SHORT) : undefined
  };
});

const sendMessage = () => {
  // Without the number there's nothing to hand WhatsApp, so restricted viewers compose
  // a message that the server delivers on their behalf.
  if (!canViewContact.value) {
    openDrawer(SendCustomerMessage, {
      customerId: props.customer.id,
      customerName: props.customer.fullName,
      onClose: closeDrawer
    }, {
      title: 'שליחת הודעה ללקוח/ה',
      closable: true
    });
    return;
  }

  try {
    sendWhatsApp(props.customer.phoneNumber);
  } catch (e) {
    console.error(e);
  }
};

const addCustomerTags = () => {
  openDrawer(AddCustomerTags, {
    onClose: closeDrawer
  }, {
    title: 'תגיות לקוח',
    closable: true
  });
};

const editCustomerLimitedServices = () => {
  openDrawer(AddCustomerLimitService, {
    onClose: closeDrawer
  }, {
    title: 'שירותים בלעדיים',
    closable: true
  });
};

const clickEditName = () => {
  if (editName.value)
    editName.value = false;
  else {
    editName.value = true;
    newClientName.value = props.customer?.fullName;
  }
};

const saveUpdatedName = () => {
  trackEvent('customer_info_updated');
  if (newClientName.value === props.customer.fullName) {
    editName.value = false;
    return;
  }

  editNameButtonLoading.value = true;
  CustomersApi.editCustomer({
    fullName: newClientName.value,
    customerId: props.customer.id!
  }).then(() => {
    toast.success('השם עודכן בהצלחה');
    editName.value = false;
    newClientName.value = '';
    // The name (and with it the sort order) changed — refetch the cached list page.
    adminClientsStore.resetCustomersList();
    emit('updated');
  }).catch((e) => {
    console.log(e);
    toast.error('לא הצלחנו לעדכן את השם');
  }).finally(() => {
    editNameButtonLoading.value = false;
  });
};

const openEditInternalNote = () => {
  openDrawer(EditCustomerNote, {
    initialValue: props.customer?.internalNote ?? '',
    placeholder: 'כתבו הערה כללית על הלקוח',
    approveLabel: 'שמירה',
    onSave: async (text: string) => {
      trackEvent('customer_info_updated');
      await CustomersApi.editCustomer({
        internalNote: text,
        customerId: props.customer.id!
      });
      toast.success('ההערה הפנימית עודכנה בהצלחה');
      emit('updated');
    },
    onClose: closeDrawer
  }, {
    title: 'הערה כללית',
    closable: true
  });
};

const phoneOnlyLoading = ref(false);
const togglePhoneOnly = async (val: boolean) => {
  if (!props.customer?.id) return;
  trackEvent('customer_info_updated');
  phoneOnlyLoading.value = true;
  try {
    await CustomersApi.editCustomer({ scheduleByPhoneOnly: val, customerId: props.customer.id });
    toast.success(val ? 'הלקוח יתבקש לקבוע תור טלפונית' : 'הלקוח יכול לקבוע תור אונליין');
    emit('updated');
  } catch {
    toast.error('העדכון נכשל');
  } finally {
    phoneOnlyLoading.value = false;
  }
};

const markerColorKey = computed(() => props.customer?.markerColor || CUSTOMER_MARKER_COLOR_DEFAULT);
const markerSubtitle = computed(() => {
  if (markerColorKey.value === CUSTOMER_MARKER_COLOR_DEFAULT) return 'סמנו את הלקוח בצבע, ותוכלו לזהות אותו בקלות בלוח השנה.';
  const labels = adminStore.businessSiteData?.customerColorLabels ?? {};
  const label = labels[markerColorKey.value];
  return label ? `תווית: ${label}` : 'הלקוח מסומן';
});

const openEditCustomerMarker = () => {
  openDrawer(EditCustomerColorMarker, {
    initialColor: markerColorKey.value,
    initialLabels: { ...(adminStore.businessSiteData?.customerColorLabels ?? {}) },
    onSave: async ({ color, labels }: { color: string; labels: Record<string, string> }) => {
      trackEvent('customer_color_marker_updated');
      const updatedLabels = await CustomersApi.updateCustomerColorLabels(labels);
      if (adminStore.businessSiteData) {
        adminStore.businessSiteData.customerColorLabels = updatedLabels;
      }
      await CustomersApi.editCustomer({
        markerColor: color,
        customerId: props.customer.id!
      });
      toast.success('הסימון עודכן בהצלחה');
      emit('updated');
    },
    onClose: closeDrawer
  }, {
    title: 'סימון לקוח',
    closable: true
  });
};

const openEditWarningNote = () => {
  openDrawer(EditCustomerNote, {
    initialValue: props.customer?.warningNote ?? '',
    placeholder: 'הערה חשובה שתוצג בעת כל תור של הלקוח',
    approveLabel: 'שמירה',
    onSave: async (text: string) => {
      trackEvent('customer_info_updated');
      await CustomersApi.editCustomer({
        warningNote: text,
        customerId: props.customer.id!
      });
      toast.success('האזהרה עודכנה בהצלחה');
      emit('updated');
    },
    onClose: closeDrawer
  }, {
    title: 'אזהרה',
    closable: true
  });
};

const removeAccount = async () => {
  trackEvent('delete_account_clicked');
  confirm.require({
    message: 'האם למחוק את הלקוח? פעולה זו תמחוק את המשתמש ואת כל התורים שלו',
    header: 'רק מוודאים',
    rejectLabel: 'לא',
    acceptLabel: 'כן',
    blockScroll: true,
    accept: async () => {
      try {
        await CustomersApi.removeCustomer(props.customer.id!);
        // The list page restores from cache — drop it so the deleted customer is gone.
        adminClientsStore.resetCustomersList();
        goTo(AdminRouteNames.Clients, { method: 'replace' });
        toast.success('לקוח נמחק בהצלחה!');
      } catch (e) {
        console.error(e);
        toast.error('לא הצלנו למחוק את הלקוח');
      }
    }
  });
};

const formatPhone = (phoneNumber: string) => {
  // Empty when the viewer isn't allowed to see contact details — don't render bare dashes.
  if (!phoneNumber) return '';
  return `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6, 10)}`;
};

</script>

<style scoped lang="scss">

</style>
